
export const convertFirestoreTimestampToDate = (_seconds: number, _nanoseconds: number): Date => {
    return new Date(_seconds * 1000 + _nanoseconds / 1000000);
};